<template>
  <div>
    <v-system-bar color="blue400"></v-system-bar>

    <v-app-bar color="#007DBC" dark app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>{{ "Posdata Referential" + ($route.meta.title ? " > " + $route.meta.title : '') }}</v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute bottom temporary>
      <v-list nav dense>
        <v-list-group :value="false" prepend-icon="mdi-domain">
          <template v-slot:activator>
            <v-list-item-title>Business Units</v-list-item-title>
          </template>
          <v-list-item-group
            v-model="group"
            active-class="activate-list-item text--accent-4"
          >
            <v-list-item
              v-for="link in links"
              :key="link.text"
              router
              :to="link.route"
            >
              <v-icon> {{ link.icon }}</v-icon>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-item  :key="this.taxes.text"
              router
              active-class="activate-list-item text--accent-4"
              :to="this.taxes.route">
          <v-icon> {{ this.taxes.icon }}</v-icon>
          <v-list-item-title>{{this.taxes.text}}</v-list-item-title>
        </v-list-item>
        <v-list-group :value="false" prepend-icon="mdi-format-list-bulleted">
          <template v-slot:activator>
            <v-list-item-title>Others</v-list-item-title>
          </template>
          <v-list-item-group
            v-model="group"
            active-class="activate-list-item text--accent-4"
          >
            <v-list-item
              v-for="link in others"
              :key="link.text"
              router
              :to="link.route"
              active-class="activate-list-item text--accent-4"
            >
              <v-icon> {{ link.icon }}</v-icon>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-group :value="false" prepend-icon="mdi-file-replace-outline">
          <template v-slot:activator>
            <v-list-item-title>Overwritten</v-list-item-title>
          </template>
          <v-list-item-group
            v-model="group"
            active-class="activate-list-item text--accent-4"
          >
            <v-list-item
              v-for="link in overwrite"
              :key="link.text"
              router
              :to="link.route"
            >
              <v-icon> {{ link.icon }}</v-icon>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {icon: "mdi-store", text: "Stores", route: "/stores"},
        {icon: "mdi-flag-variant", text: "Countries", route: "/countries"},
        {icon: "mdi-map", text: "Regions", route: "/regions"},
        {
          icon: "mdi-credit-card-wireless-outline",
          text: "ECommerces",
          route: "/ecommerces",
        },
      ],
      taxes:
        {icon: "mdi-file-document-outline", text: "Taxes", route: "/taxes"},

      others: [
        {icon: "mdi-cash", text: "Tenders", route: "/tenders"},
        {icon: "mdi-currency-eur", text: "Currencies", route: "/currencies"},
        {icon: "mdi-ticket-percent-outline", text: "MerchandiseHierarchies", route: "/merchandise-hierarchies"},
      ],
      overwrite: [
        {
          icon: "mdi-store",
          text: "Stores Overwritten",
          route: "/storesOverwritten",
        },
        {
          icon: "mdi-flag-variant",
          text: "Countries Overwritten",
          route: "/countriesOverwritten",
        },
        {
          icon: "mdi-map",
          text: "Regions Overwritten",
          route: "/regionsOverwritten",
        },
        {
          icon: "mdi-credit-card-wireless-outline",
          text: "ECommerces Overwritten",
          route: "/ecommercesOverwritten",
        },
        {
          icon: "mdi-currency-eur",
          text: "CurrenciesOverwritten",
          route: "/currenciesOverwritten",
        },
        {
          icon: "mdi-file-document-outline",
          text: "TaxesOverwritten",
          route: "/taxesOverwritten",
        },
      ],
      home: {
        text: "Home",
        route: "/",
      },
      drawer: false,
      group: null,
      activeTitle: "Posdata Referential"
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue